/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_RecipesInputs */

const en_session_recipes = /** @type {(inputs: Session_RecipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recipes`)
};

const de_session_recipes = /** @type {(inputs: Session_RecipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezepte`)
};

/**
* | output |
* | --- |
* | "Recipes" |
*
* @param {Session_RecipesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const session_recipes = /** @type {((inputs?: Session_RecipesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_RecipesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_session_recipes(inputs)
	return en_session_recipes(inputs)
});